import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';
import { Observable, Subject } from 'rxjs';
import { ApiConstants } from '../constants/api-constant';
import { SirenDetail, SirenWorkflowUpdate } from '../models/siren';

@Injectable({
  providedIn: 'root',
})
export class SirenService {
  public updateStatusMessage = new Subject<string>();
  public updateStatusMessage$ = this.updateStatusMessage.asObservable();
  public updateSirenDetails = new Subject<SirenWorkflowUpdate>();
  public updateSirenDetails$ = this.updateSirenDetails.asObservable();

  private baseUrl: string;
  constructor(private http: HttpClient) {
    this.baseUrl = environment.apiBaseUrl;
  }

  public getCommandStatusForCurrentWorkflows(controllerId: string, isLast: boolean): Observable<SirenDetail> {
    return this.http.get<SirenDetail>(
      `${this.baseUrl}${ApiConstants.BASEURL}${ApiConstants.EQUIPMENT}/equipment-siren-details/${controllerId}/${isLast}`
    );
  }

  public saveSirenDetails(workFlowSirenDetails: SirenWorkflowUpdate): Observable<any> {
    return this.http.post<any>(`${this.baseUrl}${ApiConstants.BASEURL}${ApiConstants.EQUIPMENT}/save-siren-details`, workFlowSirenDetails);
  }

  public setUpdatedSirenDetails(details: SirenWorkflowUpdate): void {
    this.updateSirenDetails.next(details);
  }

  public setUpdateStatusMessage(message: string): void {
    this.updateStatusMessage.next(message);
  }
}
